import React from 'react';

const Graduation = () => {
    return (
        <div className="programme-details">
            <div className="programme-title">
                <h2>Under - Graduation</h2>
            </div>
            <div className="programme-descripttion">
                <h3>What is Under Graduate ?</h3>
                <p>Undergraduate education is education conducted after secondary education and prior to postgraduate education. It typically includes all postsecondary programs up to the level of a bachelor's degree. For example, in the United States, an entry-level university student is known as an undergraduate, while students of higher degrees are known as graduate students. In some other educational systems, undergraduate education is postsecondary education up to the level of a master's degree; this is the case for some science courses in Britain and some medicine courses in Europe.</p>
                <h3>Our Under - Graduate Programmes : </h3>
                <ul>
                    <li>Avionics Engineering .</li>
                    <li>Aerodynamics Design .</li>
                    <li>Aircraft Material Science</li>
                    <li>Mechanical Engineering .</li>
                    <li>Software Engineering .</li>
                    <li>Nano &#38; Robo Technology .</li>
                </ul>
                <h3>Duration : </h3>
                <ul>
                    <li>Full Course 4 Years .</li>
                    <li>4 Month (each semester) .</li>
                </ul>
                <h3>What is the Pre-requerments for this course ?</h3>
                <ul>
                    <li>Must Needed English proficiency Certificate (IELTS, TOFEL, DUOLINGO etc) .</li>
                    <li>10th class or equivalente certificate .</li>
                    <li>Math &#38; Physics minimum needed 70% markes .</li>
                </ul>
            </div> 
        </div>
    );
};

export default Graduation;